import Layout from '@/components/Layout'

const orderRoutes = [
  {
    path: '/order',
    name: 'order',
    redirect: '/order/index',
    component: Layout,
    meta: {
        title: "订单管理",
        icon: "el-icon-s-check",
        show: true
    },
    children: [
      {
        path: '/order/index',
        name: 'orderIndex',
        component: () => import(/* webpackChunkName: "about" */ '../../views/order/index.vue'),
        meta: {
          show: false
        },
      }
    ]
  }
]

export default orderRoutes